import { motion } from "framer-motion";
import { useLang } from "../lang";

const EASE = [0.16, 1, 0.3, 1];

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section id="manifeste" className="px-6 py-24 md:px-10 md:py-40" data-testid="manifesto-section">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="mb-6 font-mono text-[11px] uppercase tracking-[0.25em] text-signal"
      >
        {t.manifesto.overline}
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
        className="mb-24 max-w-3xl font-display text-3xl font-semibold leading-tight tracking-tight md:text-5xl"
      >
        {t.manifesto.heading}
      </motion.h2>

      <div>
        {t.manifesto.chapters.map((c, i) => (
          <motion.article
            key={c.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: EASE, delay: i * 0.05 }}
            className="group grid grid-cols-1 gap-8 border-t border-edge/60 py-16 transition-colors duration-300 hover:border-signal/40 md:grid-cols-12 md:py-20"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <div className="md:col-span-4">
              <span className="text-outline font-display text-[6rem] font-bold leading-none transition-all duration-300 group-hover:text-outline-red md:text-[9rem]">
                {c.n}
              </span>
            </div>
            <h3 className="font-display text-2xl font-semibold leading-tight tracking-tight md:col-span-4 md:text-4xl">
              {c.t}
            </h3>
            <p className="max-w-md text-base leading-relaxed text-muted-foreground md:col-span-4">{c.b}</p>
          </motion.article>
        ))}
        <div className="border-t border-edge/60" />
      </div>
    </section>
  );
}
